export { Tabbar } from './Tabbar';
export { Footer } from './Footer';
export { Layout } from './Layout';
export { GlobalStylesUTCom } from './styles/Global';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50c3giXSwibmFtZXMiOlsiVGFiYmFyIiwiRm9vdGVyIiwiTGF5b3V0IiwiR2xvYmFsU3R5bGVzVVRDb20iXSwibWFwcGluZ3MiOiJBQUFBLFNBQVNBLE1BQVQsUUFBdUIsVUFBdkI7QUFDQSxTQUFTQyxNQUFULFFBQXVCLFVBQXZCO0FBQ0EsU0FBU0MsTUFBVCxRQUF1QixVQUF2QjtBQUNBLFNBQVNDLGlCQUFULFFBQWtDLGlCQUFsQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IFRhYmJhciB9IGZyb20gJy4vVGFiYmFyJztcbmV4cG9ydCB7IEZvb3RlciB9IGZyb20gJy4vRm9vdGVyJztcbmV4cG9ydCB7IExheW91dCB9IGZyb20gJy4vTGF5b3V0JztcbmV4cG9ydCB7IEdsb2JhbFN0eWxlc1VUQ29tIH0gZnJvbSAnLi9zdHlsZXMvR2xvYmFsJztcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/utcom-ui-kit/dist/index.js
// module id = 1589
// module chunks = 118